function BlogDateBlock({ post }) {
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    return (
        <div className="text-xs text-gray-500">
            {new Date(post.date)
                .toLocaleDateString('en-US', options)
                .toUpperCase()}
        </div>
    )
}

export default BlogDateBlock
